import React from 'react';
import { ethers } from 'ethers';

function LinkWallet() {
    const linkWallet = async () => {
        if (!window.ethereum) return alert("Wallet not found");

        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const address = await signer.getAddress();
            const message = `Link wallet to your account: ${address}`;
            const signature = await signer.signMessage(message);
            const token = localStorage.getItem("token");

            const res = await fetch("/api/auth/link-wallet", {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ message, signature })
            });

            const data = await res.json();
            if (res.ok) {
                alert(data.message || "Wallet linked!");
            } else {
                alert(data.error || "Failed to link wallet.");
            }

        } catch (err) {
            console.error(err);
            alert("Something went wrong.");
        }
    };

    return (
        <div>
            <h3>Link Wallet to Account</h3>
            <button onClick={linkWallet}>Link Wallet</button>
        </div>
    );
}

export default LinkWallet;
